import { render } from "./UserCompanies.vue?vue&type=template&id=3a1a9e0d&scoped=true"
import script from "./UserCompanies.vue?vue&type=script&lang=js"
export * from "./UserCompanies.vue?vue&type=script&lang=js"

import "./UserCompanies.vue?vue&type=style&index=0&id=3a1a9e0d&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1a9e0d"]])

export default __exports__